module.exports = __webpack_public_path__ + "static/22-d5b3eec9a21f47fd00fc6dbf4efc6c13.jpg";